import { useNavigate } from 'react-router-dom';

import { getRoute } from '@common/constants/CampusRoutes';

type ConfirmationHook = () => (props?: any) => Promise<unknown>;

interface UseCancelCreateGoalProps {
	useConfirmationHook: ConfirmationHook;
}

const useCancelCreateGoal = ({ useConfirmationHook }: UseCancelCreateGoalProps) => {
	const confirmation = useConfirmationHook();
	const navigate = useNavigate();
	const handleDelete = () => {
		confirmation({ text: 'You want to remove "goals"' })
			.then(() => navigate(getRoute(['REPORT', 'ABOUT'])))
			.catch(() => {});
	};

	return handleDelete;
};

export default useCancelCreateGoal;
